<div class="not-found">
    <!-- <h1>404 - Page Not Found</h1> -->
    <p class="fs-24 mb-3">The page you are looking for does not exist or you don't have access to it.</p>
    <a routerLink="/">Return to Home</a>
  </div>
